import { render, staticRenderFns } from "./TraineeForm.vue?vue&type=template&id=7c20b95e&scoped=true"
import script from "./TraineeForm.vue?vue&type=script&lang=js"
export * from "./TraineeForm.vue?vue&type=script&lang=js"
import style0 from "./TraineeForm.vue?vue&type=style&index=0&id=7c20b95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20b95e",
  null
  
)

export default component.exports